import React from "react";

// Material
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

// FontAwesome
import {
  faFacebookF,
  faXTwitter,
  faInstagram,
  faYoutube,
  faLinkedin
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Config
import { externalRoutes } from "../../config/urls";
import colors from "../../config/colors";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    justifyContent: "center",
    [theme.breakpoints.down(1280)]: {
      gap: theme.spacing(1)
    }
  },
  iconButton: {
    minWidth: "auto",
    width: 40,
    height: 40,
    borderRadius: "100%",
    [theme.breakpoints.down("md")]: {
      width: 28,
      height: 28,
      padding: 0
    },
    [theme.breakpoints.down("sm")]: {
      width: 50,
      height: 50
    }
  },
  faIcon: {
    fontSize: 18,
    color: colors.socialIcon,
    [theme.breakpoints.down("md")]: {
      fontSize: 12
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 18
    }
  }
}));

const socialItems = [
  {
    icon: faFacebookF,
    id: "facebook",
    url: externalRoutes.facebook
  },
  {
    icon: faXTwitter,
    id: "twitter",
    url: externalRoutes.twitter
  },
  {
    icon: faInstagram,
    id: "instagram",
    url: externalRoutes.instagram
  },
  {
    icon: faYoutube,
    id: "youtube",
    url: externalRoutes.youTube
  },
  {
    icon: faLinkedin,
    id: "linkedin",
    url: externalRoutes.linkedin
  }
];

const SocialLinks = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {socialItems.map(({ icon, id, url }) => (
        <Button
          className={classes.iconButton}
          component="a"
          href={url}
          key={id}
          target="blank"
          variant="outlined"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon className={classes.faIcon} icon={icon} />
        </Button>
      ))}
    </div>
  );
};

export default SocialLinks;
